import axios from 'axios'
const linyuanApiBase = process.env.REACT_APP_LINYUAN_API_BASE || 'http://192.168.110.41:3005'

export const linyuanApi = axios.create({
  baseURL: (linyuanApiBase || '') + '/api',
  timeout: 10000
})

linyuanApi.interceptors.response.use(
  (response) => {
    const data = response.data
    if (data && typeof data.code === 'number' && data.code !== 200) {
      const err = new Error(data.message || '请求失败')
      err.response = response
      return Promise.reject(err)
    }
    return data
  },
  (error) => Promise.reject(error)
)

linyuanApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function getNewsListFromLinyuan(currentPage, pageSize, type, lang = 0) {
  const params = {
    currentPage,
    pageSize,
    type,
    lang,
    published: 1,
    active: 1
  }
  const res = await linyuanApi.get('/news', { params })
  const apiData = res || {}
  const page = apiData.data || {}
  const list = (page.list || []).map(item => {
    const langValue = typeof item.lang === 'number' ? item.lang : Number(item.lang || 0)
    const title = item.title || (langValue === 0 ? item.title_cn : item.title_en) || item.title_cn || item.title_en || ''
    const cover = item.cover_url || ''
    const contentHtmlUrl = item.content_html_url || ''
    const detailSlug = item.detail_slug || ''

    let coverUrl = cover
    if (cover && !(cover.startsWith('http://') || cover.startsWith('https://'))) {
      coverUrl = `/images/news/${detailSlug}/${cover}`
    }

    return {
      id: item.id,
      lang: langValue,
      title,
      titleCn: item.title_cn,
      titleEn: item.title_en,
      summary: item.summary || '',
      type: item.type,
      publicationDate: item.publication_date,
      detailUrl: detailSlug,
      coverUrl,
      contentHtmlUrl
    }
  })
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize
  }
}

export async function getEmployeesFromLinyuan(currentPage = 1, pageSize = 100, lang = 0) {
  const params = {
    currentPage,
    pageSize
  }
  const res = await linyuanApi.get('/employees', { params })
  const apiData = res || {}
  const page = apiData.data || {}
  const list = (page.list || []).map(item => {
    let avatarFile
    if (!item.avatar_url) {
      // 空值情况，使用默认头像
      avatarFile = '/images/contacts/avt00.png'
    } else if (item.avatar_url.startsWith('https://')) {
      // 完整地址，直接赋值
      avatarFile = item.avatar_url
    } else {
      // 仅文件名，拼接路径
      avatarFile = `/images/contacts/${item.avatar_url}`
    }
    let products = []
    const rawProducts = item.products
    if (Array.isArray(rawProducts)) {
      products = rawProducts
    } else if (typeof rawProducts === 'string' && rawProducts.trim() !== '') {
      try {
        const parsed = JSON.parse(rawProducts)
        if (Array.isArray(parsed)) {
          products = parsed
        } else {
          products = rawProducts.split(',').map(p => p.trim()).filter(p => p)
        }
      } catch (e) {
        products = rawProducts.split(',').map(p => p.trim()).filter(p => p)
      }
    }
    const qrUrl = item.user_qr_url || ''
    const name = lang === 0 ? item.name_cn : item.name_en
    const location = lang === 0 ? item.location_cn : item.location_en
    const position = lang === 0 ? item.position_cn : item.position_en
    const division = lang === 0 ? item.division_cn : item.division_en
    return {
      id: item.id,
      avatar: avatarFile,
      name,
      location,
      position,
      division,
      products,
      email: item.email || '',
      mobile: item.mobile || '',
      qrUrl
    }
  })
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize
  }
}

export async function getOfficesFromLinyuan(currentPage = 1, pageSize = 100, lang = 0) {
  const params = {
    currentPage,
    pageSize,
    active: 1
  }
  const res = await linyuanApi.get('/offices', { params })
  const apiData = res || {}
  const page = apiData.data || {}
  const list = (page.list || []).map(item => {
    let pics = []
    const rawPics = item.pics
    if (Array.isArray(rawPics)) {
      pics = rawPics
    } else if (typeof rawPics === 'string' && rawPics.trim() !== '') {
      try {
        const parsed = JSON.parse(rawPics)
        if (Array.isArray(parsed)) {
          pics = parsed
        } else {
          pics = rawPics.split(',').map(p => p.trim()).filter(p => p)
        }
      } catch (e) {
        pics = rawPics.split(',').map(p => p.trim()).filter(p => p)
      }
    }
    const add = lang === 0 ? item.address_cn : item.address_en
    const center = {
      lng: item.longitude,
      lat: item.latitude
    }
    return {
      id: item.id,
      center,
      addCN: item.address_cn,
      addEN: item.address_en,
      add,
      pic: pics
    }
  })
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize
  }
}

export async function getPartnerCompaniesFromLinyuan(currentPage = 1, pageSize = 50) {
  const params = {
    currentPage,
    pageSize,
    isPartner: 1,
  };
  const res = await linyuanApi.get('/companies', { params });
  const apiData = res || {};
  const page = apiData.data || {};
  const list = (page.list || []).map((item) => {
    return {
      id: item.id,
      alias: item.alias,
      nameCn: item.nameCn || '',
      nameEn: item.nameEn || '',
      logoUrl: item.logoUrl || ''
    };
  });
  return {
    list,
    totalCount: page.totalCount || list.length,
    currentPage: page.currentPage || currentPage,
    pageSize: page.pageSize || pageSize,
  };
}



//获取浏览器参数
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]); return null;
}
//日期格式化
export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
    }
  }
  return fmt;
}

//用法
// let date = new Date()
// dateFormat("YYYY-mm-dd HH:MM", date)
// >>> 2019-06-06 19:45`
